<table class="sondermind-data-table"
  sondermindResizeObserver
  sondermindMediaQueryAttribute
  [attr.data-interactions]="isNavigable"
  [templateStore]="{ data: tableData, groupColumn: getGroupColumn() }"
  #tstore="templateStore"
>

  <colgroup>
    <col
      *ngIf="isSelectable"
      data-selection
      [attr.width]="checkboxDesktopWidth + 'px'"
    />
    <col *ngIf="isRolloutable" data-rollout />
    <ng-container *ngFor="let column of columnDefs">
      <col *ngIf="!isGroupable || column !== tstore.groupColumn" [attr.width]="getColumnWidth(column)" />
    </ng-container>
    <col
      *ngIf="hasNavigationArrow"
      data-navigation
      [attr.width]="buttonDesktopWidth + 'px'"
    />
  </colgroup>

  <thead
    *ngIf="header"
    [attr.data-compressed]="compressed"
    [attr.data-bleed]="contentBleed"
  >
    <tr>
      <th
        *ngIf="isSelectable && tableData.length"
        class="select-all"
        data-selection
      >
        <iris-checkbox
          [formControl]="selectAllControl"
          [indeterminate]="isSelectAllIndeterminate"
          (click)="toggleSelectAll(); $event.stopPropagation()"
          aria-label="Select All"
        >
        </iris-checkbox>
      </th>
      <th *ngIf="isRolloutable" data-rollout></th>
      <ng-container *ngFor="let column of columnDefs">
        <th
          *ngIf="!isGroupable || column !== tstore.groupColumn"
          (click)="handleHeaderClick(column, $event)"
          [attr.align]="column.align"
          [ngClass]="column.sortable ? 'sortable' : ''"
          [attr.data-test]="column.dataTest"
        >
          <ng-container *ngIf="column.sortable" [ngSwitch]="column.sort">
            <mat-icon *ngSwitchCase="'desc'">arrow_drop_down</mat-icon>
            <mat-icon *ngSwitchCase="'asc'">arrow_drop_up</mat-icon>
            <mat-icon
              *ngSwitchDefault
              sondermind-type
              theme="disabled"
            >unfold_more</mat-icon>
          </ng-container>
          {{ column.label }}
        </th>
      </ng-container>
      <th *ngIf="hasNavigationArrow" data-navigation></th>
    </tr>
  </thead>

  <tbody
    [attr.data-grouped]="isGroupable"
    [attr.data-zebra]="zebra"
    [attr.data-striped]="striped"
    [attr.data-bleed]="contentBleed"
    [attr.data-compressed]="compressed"
    data-test="sm-data-table-tbody"
  >
    <ng-container *ngIf="isGroupable; then groupRows; else nonGroupRows"></ng-container>
  </tbody>

  <tfoot *ngIf="showFooter">
    <tr>
      <td [attr.colspan]="getGroupedColumnCount()">
        <table sondermindMediaQueryAttribute>
          <tr
            *ngFor="let summary of summaryDefs"
            data-summary
            [attr.data-summary-secondary]="summary.secondary"
          >
            <td data-summary-label>{{ summary.label }}</td>
            <td data-summary-value data-test="summary-value">
              <ng-container *ngIf="summary.valueTemplate">
                <ng-container *ngTemplateOutlet="summary.valueTemplate; context: { $implicit: summary.value }"></ng-container>
              </ng-container>
              <ng-container *ngIf="!summary.valueTemplate">
                {{ summary.value }}
              </ng-container>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </tfoot>

  <ng-template #groupRows let-groupColumn>
    <ng-container *ngFor="let group of tstore.data">
      <tr data-group-header>
        <td [attr.colspan]="getGroupedColumnCount()">
          <ng-container *ngTemplateOutlet="tstore.groupColumn.template; context: rowContext(group[0])"></ng-container>
        </td>
      </tr>
      <ng-container *ngTemplateOutlet="nonGroupRows; context: groupContext(group, tstore.groupColumn)"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    #nonGroupRows
    let-rows="rows"
    let-skip="skip"
  >
    <ng-container *ngFor="let row of rows || tstore.data; let i = index">
      <ng-container *ngTemplateOutlet="isRowTemplate(row) ? rowTemplate : defaultRowTmpl; context: rowContext(row, i, skip)"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    #defaultRowTmpl
    let-row="row"
    let-i="index"
    let-skip="skip"
  >
    <tr
      (click)="handleRowClick(row, $event)"
      [attr.data-selectable]="isSelectable"
      [attr.data-navigable]="isNavigable"
      [attr.data-navigable-disabled]="!navigableRow(row)"
      [attr.data-display-row]="true"
      [attr.data-rolled-out]="rolledOutRow(row)"
    >
        <td *ngIf="isSelectable" data-selection>
          <iris-checkbox
            [formControl]="selectCheckboxes[i]"
            (click)="$event.stopPropagation()"
            aria-label="Select Row"
          ></iris-checkbox>
        </td>
        <td *ngIf="isRolloutable" data-rollout>
          <mat-icon (click)="clickRolloutChevron(row, $event)">{{rolledOutRow(row) ? "arrow_drop_down" : "chevron_right"}}</mat-icon>
        </td>
        <ng-container *ngFor="let column of columnDefs; let last = last;">
          <td
            *ngIf="column !== skip"
            [attr.align]="column.align"
            [attr.data-valign]="column.valign"
          >
            <ng-container *ngTemplateOutlet="column.template; context: rowContext(row)"></ng-container>
          </td>
        </ng-container>
        <td *ngIf="hasNavigationArrow" data-navigation>
          <button mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </td>
    </tr>
    <ng-container *ngIf="rolledOutRow(row)">
      <tr *ngFor="let rollout of rolloutDefs" [attr.data-rollout-row]="true">
        <td [attr.colspan]="totalColumnCount">
          <ng-container *ngTemplateOutlet="rollout.template, context: rowContext(row)"></ng-container>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</table>
